import { Component, createElement } from 'react';

const withInfoBoxControls = component =>
  class FloodlightVisualizationContainer extends Component {
    constructor(props) {
      super(props);
      this.state = { showInfoBox: false };
    }

    showInfoBox = () => {
      this.setState(s => ({
        showInfoBox: !s.showInfoBox,
      }));
    };

    render() {
      return createElement(component, {
        ...this.props,
        onShowInfoBox: this.showInfoBox,
        showInfoBox: this.state.showInfoBox,
      });
    }
  };

export default withInfoBoxControls;
